import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/dojo`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer les dojos
export const getDojos = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allDojos`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des dojos:", error);
  }
};

// Fonction pour récupérer un dojo par son id
export const getDojoById = async (dojoId) => {
  try {
    const response = await axios.get(`${apiUrl}/findDojo/${dojoId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du dojo:", error);
  }
};

// Fonction pour récupérer les groupes d'un dojo
export const getGroupsByDojo = async (dojoId) => {
  try {
    const response = await axios.get(`${apiUrl}/${dojoId}/groupes`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des groupes du dojo:", error);
  }
};

/// POST
// Fonction pour ajouter un dojo
export const addDojo = async (dojo) => {
  try {
    const response = await axios.post(`${apiUrl}/addDojo`, dojo, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout du dojo:", error);
  }
};

/// PUT
// Fonction pour modifier un dojo
export const updateDojo = async (dojo) => {
  try {
    const response = await axios.put(`${apiUrl}/updateDojo/${dojo.id}`, dojo, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification du dojo:", error);
  }
};

// Fonction pour modifier l'ordre des dojos
export const updateOrderDojo = async (dojos) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateOrderDojo`,
      { dojos },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la modification de l'ordre des dojos:",
      error
    );
  }
};

// Fonction pour supprimer un dojo
export const deleteDojo = async (dojoId) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteDojo/${dojoId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du dojo:", error);
  }
};
